import { Button, Text } from "@growtherapy/sprout-ui";
import { preSessionVibesOpenAtom, visitorDrawerStateAtom } from "../../state";
import { useSetAtom } from "jotai";
import { useBackgroundMusicPlayback } from "../background-action/useBackgroundMusicPlayback";
import {
  PRE_SESSION_PROMPT_CTA_INTRO_TEXT,
  VIBES_CTA_BUTTON_TEXT,
} from "./lang";

export type VibesCtaProps = {
  openPreSessionVibes: () => void;
};

export function VibesCta({ openPreSessionVibes }: VibesCtaProps) {
  return (
    <>
      <Text data-testid="pre-session-prompt-vibes" className="font-medium">
        {PRE_SESSION_PROMPT_CTA_INTRO_TEXT}
      </Text>
      <Button
        className="flex gap-4 justify-center items-center w-full"
        onClick={openPreSessionVibes}
      >
        <span>{VIBES_CTA_BUTTON_TEXT}</span>
      </Button>
    </>
  );
}

export function VibesCtaWrapper() {
  const setPreSessionVibesOpen = useSetAtom(preSessionVibesOpenAtom);
  const setDrawerState = useSetAtom(visitorDrawerStateAtom);
  const { handlePlay } = useBackgroundMusicPlayback();
  const openPreSessionVibes = () => {
    setDrawerState(null);
    setPreSessionVibesOpen(true);
    handlePlay();
  };

  return <VibesCta openPreSessionVibes={openPreSessionVibes} />;
}
